module.exports = __webpack_public_path__ + "fonts/almoni-bold-aaa.8249618.woff2";